import React from 'react';
import { useLoaderData, useOutlet } from 'react-router-dom';
import AuthProvider from '../Auth';

const AuthLayout = () => {
  const outlet = useOutlet();

  return <AuthProvider>{outlet}</AuthProvider>;
};

export default AuthLayout;
